module.exports = __webpack_public_path__ + "static/ficciones-4b937725c67680e94a405555934817e8.jpg";